import { useCallback } from 'react';
import { useBulkAssignToGroupMutation } from './useGroupOperationsMutation';
import { showToast, TOAST_SUCCESS, FIVE_SECONDS } from 'lib/utils';

const toastMessage = (count: number) =>
  count === 1 ? '1 item added/updated to group' : `${count} items added/updated to group`;

export const useBulkAddToGroup = (locationId: string) => {
  const bulkAssignMutation = useBulkAssignToGroupMutation(locationId);

  const addMultipleToGroup = useCallback(
    async (requestIds: string[], groupId: string) => {
      if (!locationId) return;
      await bulkAssignMutation.mutateAsync({
        groupId,
        childRequestIds: requestIds,
      });
      showToast(toastMessage(requestIds.length), TOAST_SUCCESS, FIVE_SECONDS);
    },
    [bulkAssignMutation, locationId]
  );

  return { addMultipleToGroup };
};
